// ABOUTME: Resolves legacy Settings capabilities from plant-scoped feature flags.
// ABOUTME: Keeps Settings feature checks independent of the retired Latest endpoint.
import {Feature} from '@hconnect/common/enums'
import {useCommonFeatureFlag} from '@hproduce/feature-flags'

import {useUrlParam} from '../../routing'

import {settingsFeatureFlagKeys} from './settingsFeatureFlags'

export const useSettingsFeature = (feature: Feature): boolean => {
  const plantId = useUrlParam('plantCode')
  const isEnabled = useCommonFeatureFlag(settingsFeatureFlagKeys[feature], {plantId})

  return isEnabled ?? false
}
